'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components


// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Tool = require('../../Tool');

var _Tool2 = _interopRequireDefault(_Tool);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _linkActions = require('../../../../element/link/linkActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Toggles the caption on and off whenever the caption tool is clicked by either changing the image element to be
 * currently editing (which by default will put the cursor into the field and show the caption), or deleting the
 * caption text and changing the image to not be editing so that the caption will no longer have focus.
 */
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        handleMouseDown: function handleMouseDown(event) {
            event.preventDefault();
            dispatch((0, _linkActions.toggleLinkAttachment)());
        }
    };
};

var AttachmentTool = function AttachmentTool(props) {
    var name = props.name,
        selectedElements = props.selectedElements;

    var hasAttachment = selectedElements.first().getIn(['content', 'link', 'hasAttachment']);
    if (!hasAttachment) return null;

    var showingAttachment = selectedElements.first().getIn(['content', 'showAttachment']);
    var iconName = showingAttachment ? 'toolbar-image-preview-on' : 'toolbar-image-preview';

    return _react2.default.createElement(
        _Tool2.default,
        _extends({}, props, { name: name || 'Caption', isActive: showingAttachment }),
        _react2.default.createElement(_Icon2.default, { name: iconName })
    );
};

AttachmentTool.propTypes = {
    name: _react2.default.PropTypes.string,
    iconName: _react2.default.PropTypes.string,
    styleCommand: _react2.default.PropTypes.string,
    styleType: _react2.default.PropTypes.string,
    showingCaption: _react2.default.PropTypes.bool,
    selectedElements: _react2.default.PropTypes.object
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AttachmentTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/attachmentTool/AttachmentTool.js
// module id = 2227
// module chunks = 0